// removed by extract-text-webpack-plugin
module.exports = {"base":"Gamefield_base--34xhk","base__external":"Gamefield_base__external--PV4WQ","baseExternal":"Gamefield_base__external--PV4WQ"};


//////////////////
// WEBPACK FOOTER
// ./components/Gamefield/Gamefield.scss
// module id = 547
// module chunks = 11 13